export default {
      id: "empty-placeholder-usage",
      viewBox: "0 0 208 240",
      url: __webpack_public_path__ + "img/icons.e72ac2e3.svg#empty-placeholder",
      toString: function () {
        return this.url;
      }
    }